module.exports = __webpack_public_path__ + "media/product/blog-2-ed12c7c5.jpg";